import { render, staticRenderFns } from "./DeviceManagement.vue?vue&type=template&id=5a666996&scoped=true"
import script from "./DeviceManagement.vue?vue&type=script&lang=js"
export * from "./DeviceManagement.vue?vue&type=script&lang=js"
import style0 from "./DeviceManagement.vue?vue&type=style&index=0&id=5a666996&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a666996",
  null
  
)

export default component.exports